/**
 * Ai Hire pipeline: one stage per application (standard ATS flow). Every tab is a filtered
 * view of these stages, so new stages or tabs only need changes here.
 */

export const AI_SHORTLIST_THRESHOLD = 75;

/** Main path, in order. `owner` is who moves an application out of the stage. */
export const STAGES = [
  { id: "applied", label: "Applied", tone: "slate", owner: "Candidate / Recruiter" },
  { id: "ai_screened", label: "AI Screened", tone: "indigo", owner: "Ai Hire" },
  { id: "ai_interviewed", label: "AI Interviewed", tone: "violet", owner: "Ai Hire" },
  { id: "shortlisted", label: "Shortlisted", tone: "sky", owner: "Recruiter" },
  { id: "interview_scheduled", label: "Interview Scheduled", tone: "amber", owner: "Recruiter" },
  { id: "interviewed", label: "Interviewed", tone: "orange", owner: "Interviewer" },
  { id: "finalized", label: "Finalized", tone: "teal", owner: "Hiring manager / Owner" },
  { id: "offer_released", label: "Offer Released", tone: "blue", owner: "Recruiter" },
  { id: "offer_accepted", label: "Offer Accepted", tone: "green", owner: "Candidate" },
  { id: "joined", label: "Joined", tone: "emerald", owner: "Recruiter" },
];

/** Exits allowed from any stage; the reason is always recorded. */
export const EXIT_STAGES = [
  { id: "rejected", label: "Rejected", tone: "red", owner: "Recruiter / Hiring manager" },
  { id: "on_hold", label: "On hold", tone: "gray", owner: "Recruiter" },
  { id: "withdrawn", label: "Withdrawn", tone: "gray", owner: "Candidate" },
  { id: "offer_declined", label: "Offer Declined", tone: "red", owner: "Candidate" },
];

const ALL = [...STAGES, ...EXIT_STAGES];
const BY_ID = Object.fromEntries(ALL.map((s) => [s.id, s]));

export const stageOf = (id) => BY_ID[id] || { id, label: id, tone: "gray", owner: "" };

/** Position on the main path (exits return -1). */
export const stageIndex = (id) => STAGES.findIndex((s) => s.id === id);

/** True when the application reached `id` (or went past it) on the main path. */
export const reached = (stage, id) => stageIndex(stage) >= stageIndex(id);

/** Which stages each tab lists. */
export const TAB_STAGES = {
  candidates: ["applied", "ai_screened", "ai_interviewed", "shortlisted", "rejected"],
  interviews: ["shortlisted", "interview_scheduled", "interviewed"],
  finalized: ["finalized"],
  offers: ["offer_released", "offer_accepted", "offer_declined", "joined"],
};

export const AI_RECOMMENDATIONS = {
  Strong: "green",
  Consider: "amber",
  Reject: "red",
};

export function recommendationFor(score) {
  if (score == null) return null;
  if (score >= AI_SHORTLIST_THRESHOLD) return "Strong";
  if (score >= 60) return "Consider";
  return "Reject";
}
